module.exports = __webpack_public_path__ + "static/06-a152d6563ac2897c720ecfce45bc20d1.jpg";